import { render, staticRenderFns } from "./addbutton.vue?vue&type=template&id=14943673&scoped=true&"
import script from "./addbutton.vue?vue&type=script&lang=js&"
export * from "./addbutton.vue?vue&type=script&lang=js&"
import style0 from "./addbutton.vue?vue&type=style&index=0&id=14943673&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14943673",
  null
  
)

export default component.exports